(function () {
    angular.module('emarket.main.profile').controller('ChatDetailController', ['$scope', '$state', '$timeout', '$log', '$stateParams', '$mdDialog', '$mdMedia', '$q', 'Chat', 'Announcer', 'Auth', 'Utils', 'Socket', function ($scope, $state,  $timeout, $log, $stateParams, $mdDialog, $mdMedia, $q, Chat, Announcer, Auth, Utils, Socket) {
        var vm = this;
        var user = Auth.getUser();
        vm.isMobile = $mdMedia('xs') || $mdMedia('sm');
        var announcer = Announcer.createEmitter();
        var socket;
        var chatChannel = 'chats/'+ ($stateParams.id || $stateParams.chat._id);
        var scrollTop = function () {
            Utils.scrollTo('button', '.md-content__message-wrapper');
        };
        scrollTop();
        var getChat = function() {
            if($stateParams.chat) {
                return $q.when($stateParams.chat);
            } else {
                return Chat.$find($stateParams.id).$asPromise();
            }
        };
        Socket.then(function(_socket) {
            socket = _socket;
            socket.emit('subscribe', {
                module:chatChannel
            }, function() {

            });
            socket.on('chat/message', function(msg, ack) {
                $timeout(function() {
                    vm.chat.messages.push(msg);
                    scrollTop();
                });
                ack();
            });
            socket.on('connect', function() {
                socket.emit('subscribe', {
                    module:chatChannel
                }, function() {

                });
            });
        });
        vm.isLoading = true;
        if(vm.isMobile && !$stateParams.isDialog) {
            announcer.emit(Announcer.types.FULL_SCREEN_MODE_NO_TOOLBAR);
        }
        getChat().then(function(chat) {
            chat.participants = chat.participants.filter(function (participant) {
                return participant._id !== user._id;
            });
            vm.chat = chat;
            return Chat.getMessages(chat._id);
        }).then(function(messages) {
            announcer.emit(Chat.events.ON_SELECT_CHAT, vm.chat);
            vm.chat.messages = messages;
            vm.isLoading = false;
            scrollTop();

        }).catch(function() {
            vm.isLoading = false;
        });
        vm.isDialog = $stateParams.isDialog;
        vm.getProfilePicture = function(from) {
            if(vm.isMe(from)) {
                return user.picture;
            } else {
                return vm.chat.participants[0].picture;
            }
        };
        var updateMessage = function(message, id) {
            vm.chat.messages.some(function(msg, index) {
                if(msg.id === id) {
                    vm.chat.messages[index] = message;
                    return true;
                }
            });
        };
        vm.send = function () {
          //ignore if not message whas send
            if(!vm.message) {
                return ;
            }
            var message = vm.message;
            var id = Math.random() * 9999;

            vm.chat.messages.push({
                body:message,
                from: user._id,
                pending: true,
                id: id
            });
            scrollTop();
            socket.emit('chat/message', {
                chat:vm.chat._id,
                message:message
            }, function(err, msg) {
                updateMessage(msg, id);
                scrollTop();
                if(err) {
                    $log.error(err);
                }
            });
            vm.message = '';
        };

        vm.closeDialog = function () {
            if(vm.isDialog) {
                $mdDialog.hide();
            } else {
                $state.go('main.profile.chat', {}, {location:'replace'});
            }
        };
        vm.detectKey = function (event) {
            if (event.which === 13) {
                vm.send();
            }
        };

        vm.isMe = function (id) {
            return user._id === id;
        };

        $scope.$on('$destroy', function () {
            // ev();
            if(socket) {
                socket.emit('unsubscribe', {
                    module: chatChannel
                }, function() {

                });
            }
        });
    }]);
}());
